import CoreFilter from "../../../../app/core/components/CoreFilter/CoreFilter";
import AutocompleteFilter from "../../../../app/core/components/CoreFilter/components/AutocompleteFilter/AutocompleteFilter";
import { ROLE } from "../../../../utils/constants/profiles";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import { useGetStudiosQuery } from "../../../api/admin/gestisciStudioApi";
import { useGetCommercialistaQuery } from "../../../api/admin/gestisciCommercialistiApi";
import { useGetUsersQuery } from "../../../api/admin/gestisciUtentiApi";
import useSyncFilterWithGlobalFilters from "../../../../utils/hookCustom";
import { useDispatch, useSelector } from "react-redux";
import {
  removeGlobalFilter,
  setMultipleGlobalFilters,
} from "../../../../app/globalFiltersSlice.js";
import { selectAllFilters } from "../../../../app/globalFiltersSlice";
import { useGetServicesQuery } from "../../../api/admin/ServiziApi.js";
import { useGetPracticeManagementQuery } from "../../../api/admin/gestisciPraticheApi.js";
import { t } from "i18next";
import DataFilter from "../../../../app/core/components/CoreFilter/components/DataFilter/DataFilter.jsx";

const FilterActivity = ({ filter, setFilter }) => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.app.role);
  const globalFilters = useSelector(selectAllFilters);

  const statesActivity = [
    { value: "Aperta", label: "Aperta" },
    { value: "InAttesa", label: "In Attesa" },
    { value: "InLavorazione", label: "In Lavorazione" },
    { value: "Annullata", label: "Annullata" },
    { value: "ChiusaPositivo", label: "Chiusa Positivo" },
    { value: "ChiusaChiusaNegativo", label: "Chiusa Negativo" },
  ];

  const page = {
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  };

  const { data: dataStudio, isLoading: isLoadingStudio } = useGetStudiosQuery(
    {
      ...page,
      studioId: filter.studioId,
    },
    { skip: ROLE.USER === role }
  );

  const { data: dataOperators, isLoading: isLoadingOperators } =
    useGetCommercialistaQuery(
      {
        page,
        adminId: filter.adminId,
      },
      { skip: ROLE.USER === role }
    );

  const { data: dataUsers, isLoading: isDataUsersLoading } = useGetUsersQuery(
    {
      page: { startRow: 0, endRow: 20 },
      userId: filter.userId,
    },
    { skip: ROLE.USER === role }
  );

  const { data: dataService, isLoading: loadingService } = useGetServicesQuery(
    page,
    {
      serviceId: filter.serviceId,
    }
  );

  const { data: practicesData, isLoading: practicesLoading } =
    useGetPracticeManagementQuery({
      page,
      practiceId: filter.practiceId,
    });

  // Funzione per trasformare i filtri dal formato array al formato oggetto
  const transformFilters = (filtersArray) => {
    const filterObject = {
      adminId: "",
      studioId: "",
      userId: "",
      serviceId: "",
      practiceStatus: "",
      practiceId: "",
      startDate: "",
      endDate: "",
    };

    filtersArray.forEach((filter) => {
      if (
        filter.key &&
        Object.prototype.hasOwnProperty.call(filterObject, filter.key)
      ) {
        filterObject[filter.key] = filter.value || "";
      }
    });

    return filterObject;
  };

  const handleFiltersChange = (filters) => {
    // Trasforma i filtri nel formato desiderato
    const transformedFilters = transformFilters(filters);

    // Ora puoi usare l'oggetto trasformato
    setFilter(transformedFilters);
  };

  const handleGlobalFiltersApply = (filters) => {
    // Separa i filtri con valori validi da quelli undefined/vuoti
    const validFilters = [];
    const filtersToRemove = [];

    filters.forEach((filter) => {
      if (filter.value !== undefined && filter.value !== "") {
        // Filtro con valore valido - mantienilo
        validFilters.push(filter);
      } else {
        // Filtro undefined o vuoto - rimuovilo
        filtersToRemove.push(filter.key);
      }
    });

    // Rimuovi i filtri undefined/vuoti dallo state
    filtersToRemove.forEach((filterKey) => {
      dispatch(removeGlobalFilter(filterKey));
    });

    // Imposta solo i filtri con valori validi
    if (validFilters.length > 0) {
      dispatch(setMultipleGlobalFilters(validFilters));
    }
  };

  useSyncFilterWithGlobalFilters(setFilter);

  return (
    <div>
      {" "}
      <CoreFilter
        onFiltersChange={handleFiltersChange}
        onGlobalFiltersApply={handleGlobalFiltersApply}
        initialFilters={globalFilters}
      >
        {role === ROLE.ADMIN && (
          <AutocompleteFilter
            label="Cerca Studio"
            placeholder="Digita nome studio..."
            options={dataStudio?.Data?.items}
            filterKey="studioId"
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            allowGlobal={true}
          />
        )}

        {role !== ROLE.OPERATOR && (
          <AutocompleteFilter
            label="Cerca Operatore"
            placeholder="Digita nome operatore..."
            options={dataOperators?.Data?.items}
            filterKey="adminId"
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => `${option.name} ${option.surname}`}
            allowGlobal={true}
          />
        )}

        <AutocompleteFilter
          label="Cerca Cliente"
          placeholder="Digita nome cliente..."
          options={dataUsers?.Data?.items}
          filterKey="userId"
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => `${option.name} ${option.surname}`}
          allowGlobal={true}
        />

        <AutocompleteFilter
          label="Cerca Servizio"
          placeholder="Digita nome servizio..."
          options={dataService?.Data?.items}
          filterKey="serviceId"
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
        />

        <AutocompleteFilter
          label="Cerca Attività"
          placeholder="Digita nome attività..."
          options={practicesData?.Data?.items}
          filterKey="practiceId"
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
        />

        <AutocompleteFilter
          label="Cerca Stato"
          placeholder="Digita nome stato..."
          options={statesActivity}
          filterKey="practiceStatus"
          getOptionValue={(option) => option.value}
          getOptionLabel={(option) => option.label}
        />

        <DataFilter
          filterKey="startDate"
          label={t("StartDate")}
          currentFilter={filter.startingDate}
        />
        <DataFilter
          filterKey="endDate"
          label={t("EndDate")}
          currentFilter={filter.endingDate}
        />
      </CoreFilter>
    </div>
  );
};

export default FilterActivity;
